import * as React from "react";
import * as Rx from "rxjs";
import * as Util from "Util";

export class Component<T, S> extends React.Component<T, S>  {
	constructor(props: T) {
		super(props);		
	}
	/*
		Sauce components expose a subscription that is cleaned up when the component is unmounted.
	*/
	private subscription: Rx.Subscription = new Rx.Subscription();
	add(sub: Rx.Subscription) {
		return this.subscription.add(sub);
	}
	subscribe<T>(observable: Rx.Observable<T>, observer: (next: T) => void | Rx.Observer<T>) {
		let sub = observable.subscribe(observer);
		this.subscription.add(sub);
		return sub;
	}

	remove(sub: Rx.Subscription) {
		this.subscription.remove(sub);
		sub.unsubscribe();
	}
	componentWillUnmount() {
		this.subscription.unsubscribe();
	}
}



// WEBPACK FOOTER //
// ./src/code/Sauce/Base.ts